import { registerHubSection } from '@/guidance/hub-sections';

import { HUB_SECTION_TITLE } from './copy';
import { IntegrationsHubSection } from './integrations-hub-section';
import { useIntegrationsHubVisible } from './use-integrations-hub-visible';

/**
 * Side-effect module: registers «اتصال به سایت و سامانه‌های دیگه» in the
 * «راهنما و پیشنهادها» hub (public-api design §15 — no tour, a section).
 * Import it once from `main.tsx`, next to `features/guide/register`, so the
 * section exists before the settings chunk ever loads. Order 300: after the
 * smart guide (10) and «شروع کار» (100).
 */
export const unregisterIntegrationsHubSection = registerHubSection({
  key: 'integrations',
  order: 300,
  title: HUB_SECTION_TITLE,
  Component: IntegrationsHubSection,
  useVisible: useIntegrationsHubVisible,
});
